import React from 'react';
import cn from 'classnames';
// import {Link} from 'react-router-dom';
// import {useReservation} from 'context/reservation';
// import {getHousingName} from 'utils/reservation';
// import Button from 'components/acommon/Button';
// import Icon from 'components/acommon/Icon';
// import Language from 'components/acommon/Language';
import chekinLogo from 'assets/chekin-logo.svg';
import styles from './Footer.module.sass';
import Language from '../Language';

// const items = [
//   {
//     title: 'Experiences',
//     url: '/exp',
//     button: true,
//   },
//   {
//     title: 'Support',
//     url: '/support',
//   },
//   {
//     title: 'Privacy Policy',
//     url: '/privacy',
//   },
//   {
//     title: 'Therms of use',
//     url: '/therms',
//   },
// ];
type FooterProps = {
  paddingBottonMobile?: boolean;
  onlyForMobile?: boolean;
};
const Footer = ({paddingBottonMobile, onlyForMobile}: FooterProps) => {
  // const {data} = useReservation();
  // const housingName = getHousingName(data);

  return (
    <div
      className={cn(styles.footer, {
        [styles.paddingBottomMobile]: paddingBottonMobile,
        [styles.footerMobile]: onlyForMobile,
      })}
    >
      <div className={styles.container}>
        {/* <div className={cn(styles.row, styles.mobileOnly, styles.mobileFooter)}>
          <Language className={styles.iconButton} />
          <div className={styles.powered}>
            powered by
            <img src={chekinLogo} alt="Chekin" />
          </div>
          <Link to="/support">
            <Icon name="clock" className={styles.iconButton} />
          </Link>
        </div>
        <div className={cn(styles.row, styles.desktopOnly)}>
          <div className={styles.col}>
            <Link className={styles.logo} to="/">
              <span className={styles.logoName}>{housingName}</span>
            </Link>
          </div>
          <div className={styles.col}>
            <div className={styles.menu}>
              {items.map((x, index) =>
                x.button ? (
                  <Button size="medium" stroke to={x.url} key={index}>
                    {x.title}
                  </Button>
                ) : (
                  <Link className={styles.link} to={x.url} key={index}>
                    {x.title}
                  </Link>
                ),
              )}
            </div>
          </div>
        </div> */}
        {!onlyForMobile && (
          <div className={cn(styles.bottom, styles.desktopOnly)}>
            <div className={styles.copyright}>Copyright © 2021</div>
            <div className={styles.copyright}>All rights reserved</div>
            <div className={styles.powered}>
              powered by
              <img src={chekinLogo} alt="Chekin" />
            </div>
          </div>
        )}
        <div className={cn(styles.bottom, styles.mobileOnly)}>
          <Language className={cn(styles.language, styles.languageFooter)} />
          <div className={styles.powered}>
            powered by
            <img src={chekinLogo} alt="Chekin" />
          </div>
        </div>
      </div>
    </div>
  );
};

export {Footer};
